import React from "react";
import { Modal } from "reactstrap";
import "assets/css/safexpay-web.css";
import "./Registration.css";
import Spinner from "reactstrap/lib/Spinner";
import privacyDoc from "../../assets/pdf/PrivacyPolicy.pdf";
import termDoc from "../../assets/pdf/Terms&Conditions.pdf";
import { left } from "@popperjs/core";
import { base_url } from "assets/utils/const";
import { CompanyNameValidation } from "assets/utils/constFuntion";
import {
  nameValidation,
  nameRegisterValidation,
} from "assets/utils/constFuntion";
class BusinessDetails extends React.Component {
  toggleModal = (state) => {
    this.setState({
      [state]: !this.state[state],
    });
  };

  state = {
    BusinessCategories: [],
    selectedBusinessCategory: "",
    isLoaded: false,
    brandName: "",
    registeredName: "",
    businessSubCategory: "",
    website: "",
    user_id: "",
    brandNameError: false,
    websiteError: false,
    registeredNameError: false,
    subCategoryError: false,
    authToken: localStorage.getItem("Authtoken"),
  };

  componentDidMount() {
    if (!localStorage.getItem("Authtoken")) {
      window.location.href = "/login";
    }
    // console.log('')
    fetch(`${base_url}api/dmoCategoryMaster/agId/paygate`)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        //debugger;
        //console.log(data);
        const valuesArray = data.json;
        //console.log(valuesArray);
        let BusinessCategoriesFromApi = valuesArray.map((BusinessCategory) => {
          return {
            value: BusinessCategory.id,
            display: BusinessCategory.category,
          };
        });
        //console.log(BusinessCategoriesFromApi);
        this.setState({
          BusinessCategories: [
            { value: "", display: "Select Business Category" },
          ].concat(BusinessCategoriesFromApi),
        });
      })
      .catch((error) => {
        console.log(error);
      });
    fetch(`${base_url}api/dmoAuthApi`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods":
          "GET, POST, PATCH, PUT, DELETE, OPTIONS",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        token: this.state.authToken,
      }),
    })
      .then((res) => res.json())
      .then((result) => {
        // console.log("result", result);
        if (result.statusCode == "200") {
          const payloadDetails = JSON.parse(result.payLoad);

          console.log("payload detalis", payloadDetails);
          this.setState({
            user_id: payloadDetails.user_id,
          });
        } else {
          if (
            result.payLoad === `Session Expired Please Login` ||
            result.payLoad === `Incorrect Token`
          ) {
            this.toggleModal("loginModal");
          }
        }
      });
  }

  handleSubmit = () => {
    this.setState({ isLoaded: true });
    var uname = localStorage.getItem("umail");
    // var brand = event.target.txtBrandName.value;
    // var rname = event.target.txtBusinessRegisteredName.value;
    // var cat = event.target.ddlBusinessCategory.value;
    // var subcat = event.target.ddlBusinessSubCategory.value;
    // var web = event.target.txtWebsite.value;

    fetch(`${base_url}api/businessAddress`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods":
          "GET, POST, PATCH, PUT, DELETE, OPTIONS",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Accept: "application/json",
        "Content-Type": "application/json",
        auth: this.state.authToken,
      },
      body: JSON.stringify({
        ag_id: "paygate",
        user_id: this.state.user_id,
        details: {
          Brand_name: this.state.brandName,
          Business_registered_name: this.state.registeredName,
          business_category: this.state.selectedBusinessCategory,
          sub_category: this.state.businessSubCategory,
          website_url: this.state.website,
        },
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          //alert(result);
          this.setState({ isLoaded: false });

          if (result.statusCode == "200") {
            var result1 = JSON.parse(result.payLoad);
            // localStorage.setItem("ucat", result1.category_name);
            // localStorage.setItem("ucatid", result1.category_id);
            // localStorage.setItem("usubcat", this.state.businessSubCategory);
            // localStorage.setItem("umobile", result1.merchant_mobile_number);
            // localStorage.setItem("btype", result1.BusinessType);
            // localStorage.setItem("umeid", result1.me_id);
            this.toggleModal("webDocsModal");
            //console.log(result);
            window.location.href = "/bank";
          } else {
            if (
              result.payLoad === `Session Expired Please Login` ||
              result.payLoad === `Incorrect Token`
            ) {
              this.toggleModal("loginModal");
              this.toggleModal("webDocsModal");
            }
          }
        },
        (error) => {
          this.setState({ isLoaded: false });
          //alert('Failed');
        }
      );
  };
  handleWebDocModal = (e) => {
    e.preventDefault();
    if (!this.handleBrandName()) {
      return false;
    }
    if (!this.handleRegisterName()) {
      return false;
    }

    if (!this.handleSubCategory()) {
      return false;
    }

    if (!this.handleWebsite()) {
      return false;
    }
    this.toggleModal("webDocsModal");
  };
  handleLogin = () => {
    this.toggleModal("loginModal");
    window.location.href = "/login";
  };
  handleBrandName = () => {
    this.setState({
      brandName:
        this.state.brandName.trim().charAt(0).toUpperCase() +
        this.state.brandName.trim().slice(1),
    });
    if (!CompanyNameValidation(this.state.brandName.trim())) {
      this.setState({ brandNameError: true });
      document.getElementById("txtBrandName").classList.add("is-invalid");
      return false;
    } else {
      this.setState({ brandNameError: false });
      document.getElementById("txtBrandName").classList.remove("is-invalid");
      return true;
    }
  };
  handleRegisterName = () => {
    this.setState({
      registeredName:
        this.state.registeredName.trim().charAt(0).toUpperCase() +
        this.state.registeredName.trim().slice(1),
    });
    if (!nameRegisterValidation(this.state.registeredName.trim())) {
      this.setState({ registeredNameError: true });
      document
        .getElementById("txtBusinessRegisteredName")
        .classList.add("is-invalid");
      return false;
    } else {
      this.setState({ registeredNameError: false });
      document
        .getElementById("txtBusinessRegisteredName")
        .classList.remove("is-invalid");
      return true;
    }
  };
  // /https?:\/\/(?:www\\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\\.[^\\s]{2,}|www\\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\\.[^\\s]{2,}|https?:\/\/(?:www\\.|(?!www))[a-zA-Z0-9]\\.[^\\s]{2,}|www\\.[a-zA-Z0-9]\\.[^\\s]{2,}/;
  // const webValidation =
  //   /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;
  handleWebsite = () => {
    console.log("website error=>", this.state.websiteError);
    console.log("website", this.state.website);
    this.setState({ website: this.state.website.trim() });
    const webValidation =
      /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/gm;
    if (!webValidation.test(this.state.website.trim())) {
      this.setState({ websiteError: true });
      document.getElementById("txtWebsite").classList.add("is-invalid");
      return false;
    } else {
      this.setState({ websiteError: false });
      document.getElementById("txtWebsite").classList.remove("is-invalid");
      return true;
    }
  };
  handleSubCategory = () => {
    this.setState({
      businessSubCategory:
        this.state.businessSubCategory.trim().charAt(0).toUpperCase() +
        this.state.businessSubCategory.trim().slice(1),
    });
    const subCatValidation = /^[A-Za-z .',_-]{1,20}$/;
    if (!subCatValidation.test(this.state.businessSubCategory.trim())) {
      this.setState({ subCategoryError: true });
      document
        .getElementById("ddlBusinessSubCategory")
        .classList.add("is-invalid");
      return false;
    } else {
      this.setState({ subCategoryError: false });
      document
        .getElementById("ddlBusinessSubCategory")
        .classList.remove("is-invalid");
      return true;
    }
  };
  render() {
    return (
      <>
        <section className="dv-Registration-content">
          <div className="first-bg htg"></div>
          <div className="container">
            <div className="row">
              <div
                className="col-md-6 dv-instruction"
                data-aos="fade-right"
                data-aos-duration="1000"
              >
                <h1 className="section-heading">
                  Quick &amp; Easy Activation Process
                </h1>
                <div className="row">
                  <div className="col-md-4 pr-0">
                    <div className="dv-step completed">
                      <div className="step">Step 1</div>
                      <div className="text">
                        Check email for Username &amp; OTP.
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 pr-0">
                    <div className="dv-step completed">
                      <div className="step">Step 2</div>
                      <div className="text">
                        Enter Username &amp; OTP. <br />
                        Set a desirable password.
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 pr-0">
                    <div className="dv-step">
                      <div className="step">Step 3</div>
                      <div className="text">
                        Fill in all the details &amp; upload documents to start
                        activation process.
                      </div>
                    </div>
                  </div>
                </div>
                <ul className="tick mt-3 mr-5">
                  <li>
                    Business Overview <span className="hr-white"></span>{" "}
                  </li>
                  {/* <li>Business Contact Details <span className="hr-white"></span></li> */}
                  <li>
                    Bank Account Details <span className="hr-white"></span>
                  </li>
                  <li>Agreement &amp; KYC Documents</li>
                </ul>
              </div>
              <div
                className="col-md-6 form-div"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                <form
                  onSubmit={this.handleWebDocModal}
                  className="dv-login-form dv-form pt-4"
                >
                  <div className="form-group">
                    <label htmlFor="txtBrandName">
                      Brand Name<span className="red">*</span>
                    </label>
                    <input
                      type="text"
                      required
                      className="form-control"
                      name="txtBrandName"
                      id="txtBrandName"
                      value={this.state.brandName}
                      onChange={(e) =>
                        this.setState({ brandName: e.target.value })
                      }
                      onBlur={this.handleBrandName}
                      placeholder="Trade
                      Name as per GST(if GST applicable)"
                    />
                    {this.state.brandNameError && (
                      <div>
                        <small style={{ color: "red" }}>
                          Invalid brand name.
                        </small>
                      </div>
                    )}
                  </div>
                  <div className="form-group">
                    <label htmlFor="txtBusinessRegisteredName">
                      Business Registered Name<span className="red">*</span>
                    </label>
                    <input
                      type="text"
                      required
                      className="form-control"
                      name="txtBusinessRegisteredName"
                      id="txtBusinessRegisteredName"
                      placeholder="Legal Name as per GST(if GST applicable)"
                      value={this.state.registeredName}
                      onChange={(e) =>
                        this.setState({ registeredName: e.target.value })
                      }
                      onBlur={this.handleRegisterName}
                    />
                    {this.state.registeredNameError && (
                      <div>
                        <small style={{ color: "red" }}>
                          Invalid register name.
                        </small>
                      </div>
                    )}
                  </div>
                  {/* <div className="form-group">
                                        <label htmlFor="ddlBusinessType">Business Type</label>
                                        <select className="custom-select" id="ddlBusinessType">
                                            <option>Please select</option>
                                            <option value="Individual">Individual</option>
                                            <option value="Proprietorship">Proprietorship</option>
                                            <option value="Partnership/LLP">Partnership / LLP</option>
                                            <option value="PrivateLtd./PublicLtd.">Private Ltd. / Public Ltd.</option>
                                            <option value="Trust/Society">Trust/ Society</option>
                                        </select>
                                    </div> */}

                  <div className="form-group sel-cust">
                    <label htmlFor="ddlBusinessCategory">
                      Business Category<span className="red">*</span>
                    </label>

                    <select
                      required
                      className="custom-select"
                      name="ddlBusinessCategory"
                      id="ddlBusinessCategory"
                      value={this.state.selectedBusinessCategory}
                      onChange={(e) =>
                        this.setState({
                          selectedBusinessCategory: e.target.value,
                        })
                      }
                    >
                      {this.state.BusinessCategories.map((BusinessCategory) => (
                        <option
                          key={BusinessCategory.value}
                          value={BusinessCategory.value}
                        >
                          {BusinessCategory.display}
                        </option>
                      ))}
                    </select>
                  </div>
                  {/* <div className="form-group">
                                        <div className="label-upld">
                                            <label htmlFor="ddlBusinessSubCategory">FSSAI No.<span className="red">*</span></label>
                                            <span className="upld-txt">upload FSSAI certificate copy</span>
                                        </div>
                                        <button className="btn upld-btn" type="button" onClick={() => this.toggleModal("uploadModal")}>
                                             UPLOAD CERTIFICATE COPY
                                        </button>
                                        
                                        <input type="text" required className="form-control" name="ddlBusinessSubCategory" id="ddlBusinessSubCategory" placeholder="Please Enter" />
                                    </div> */}
                  <div className="form-group">
                    <label htmlFor="ddlBusinessSubCategory">
                      Business Sub Category <span className="red">*</span>
                    </label>
                    {/* <select className="custom-select" id="ddlBusinessSubCategory">
                                            <option>Please select</option>
                                        </select> */}
                    <input
                      type="text"
                      className="form-control"
                      name="ddlBusinessSubCategory"
                      id="ddlBusinessSubCategory"
                      placeholder="Please Enter"
                      value={this.state.businessSubCategory}
                      onChange={(e) =>
                        this.setState({ businessSubCategory: e.target.value })
                      }
                      onBlur={this.handleSubCategory}
                      required
                    />
                    {this.state.subCategoryError && (
                      <div>
                        <small style={{ color: "red" }}>
                          Invalid sub category name.
                        </small>
                      </div>
                    )}
                  </div>
                  {/*<div className="form-group">
                    <label className="d-block" htmlFor="rdWebsite">
                      Do You Have A Website?<span className="red">*</span>
                    </label>
                     <div className="custom-control custom-radio custom-control-inline my-3">
                      <input
                        type="radio"
                        id="rdWebsite1"
                        name="rdWebsite"
                        value="Yes"
                        required
                        className="custom-control-input"
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="rdWebsite1"
                      >
                        Yes
                      </label>
                    </div>
                    <div className="custom-control custom-radio custom-control-inline">
                      <input
                        type="radio"
                        id="rdWebsite2"
                        name="rdWebsite"
                        value="No"
                        defaultChecked
                        className="custom-control-input"
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="rdWebsite2"
                      >
                        No
                      </label>
                    </div>
                    <input
                      type="text"
                      className="form-control d-none"
                      name="txtWebsite"
                      id="txtWebsite"
                      placeholder="Company.com"
                    />
                   </div> */}
                  <div className="form-group">
                    <label htmlFor="txtWebsite">
                      Website<span className="red">*</span>
                    </label>
                    <input
                      type="text"
                      required
                      className="form-control"
                      name="txtWebsite"
                      id="txtWebsite"
                      placeholder="https://www.safexpay.com/"
                      value={this.state.website}
                      onChange={(e) =>
                        this.setState({ website: e.target.value })
                      }
                      onBlur={this.handleWebsite}
                    />
                    {this.state.websiteError && (
                      <div>
                        <small style={{ color: "red" }}>
                          Invalid website name.
                        </small>
                      </div>
                    )}
                  </div>
                  <div className="form-group">
                    <p>
                      Below information link to be provided on the website.
                      <br />
                      <label>
                        <a href={privacyDoc} target="_blank">
                          Privacy Policy
                        </a>
                      </label>
                      <br />
                      <label>
                        <a href={termDoc} target="_blank">
                          {" "}
                          Terms &amp; Conditions
                        </a>
                      </label>{" "}
                    </p>
                  </div>
                  <div className="btn-holder mt-5 text-center">
                    <button
                      type="submit"
                      className={
                        this.state.isLoaded
                          ? `btn btn-next btn-gradient disable-btn`
                          : `btn btn-next btn-gradient`
                      }
                    >
                      Save &amp; Next
                    </button>
                  </div>
                  {/* <div class="btn-holder mt-2 text-center">
                                                <a href="/thankyou" class="btn btn-next btn-green">Save &amp; Next</a>
                                                </div> */}

                  <div className="dv-bottom-bg mt-5">
                    <div className="dv-help">
                      Need help?{" "}
                      <a href="/support" className="lnk-contact text-underline">
                        SUPPORT
                      </a>
                    </div>
                    <div className="first-bottom-bg"></div>
                    <div className="second-bottom-bg"></div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
        <Modal
          className="modal-dialog-centered modal-lg uploadModal"
          isOpen={this.state.uploadModal}
          toggle={() => this.toggleModal("uploadModal")}
        >
          <div className="modal-body p-4">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("uploadModal")}
            >
              <span aria-hidden={true}>×</span>
            </button>
            <div className="dv-upload">
              <div className="dv-upload-header">
                <h5>Upload Image</h5>
              </div>
              <div className="dv-upload-img">
                <p>Upload Image</p>
              </div>
              <div className="btn-holder mt-5 text-center">
                <button className="btn btn-gradient bt-wd">Submit</button>
              </div>
              {/* <div className="dv-upload-progress">
                                <p>Uploaded image is getting veriﬁed , Please wait.</p>
                                <div className="progress">
                                    <div className="progress-bar progress-bar-striped bg-success" role="progressbar" style={{width: "80%"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div> */}
            </div>
          </div>
        </Modal>
        <Modal
          className="modal-dialog-centered modal-lg webDocsModal"
          isOpen={this.state.webDocsModal}
          toggle={() => this.toggleModal("webDocsModal")}
        >
          <div className="modal-body  modal-shadow p-4">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("webDocsModal")}
            >
              <span aria-hidden={true}>×</span>
            </button>
            <div>
              <p style={{ fontSize: "1.25rem" }}>
                Please note, below are the policies that are mandatorily
                required to be available on the website:
              </p>
              <ul style={{ marginLeft: "1rem" }}>
                <li>About us</li>
                <li>Privacy Policy</li>
                <li>Terms & conditions</li>
                <li>Refund & Cancellation policy</li>
                <li>Shipping Policy (If Applicable)</li>
                <li>Legal Entity with registered office address</li>
                <li>Contact number & Email Id</li>
                <li>Service Pricing</li>
              </ul>
            </div>
            <div className="btn-holder mt-5 text-center">
              <button
                className={
                  this.state.isLoaded
                    ? `btn btn-next btn-gradient disable-btn`
                    : `btn btn-next btn-gradient`
                }
                onClick={this.handleSubmit}
                disabled={this.state.isLoaded}
              >
                Next
                {this.state.isLoaded ? (
                  <Spinner size="sm" color="light" className="btn-loader" />
                ) : null}
              </button>
            </div>
          </div>
        </Modal>
        <Modal
          className="modal-dialog-centered modal-lg loginModal"
          isOpen={this.state.loginModal}
          toggle={() => this.toggleModal("loginModal")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            {/* <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("loginModal")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button> */}
            <h5 style={{ textAlign: "center" }}>
              Session Expired, Please Login to continue
            </h5>
            <div className="btn-holder mt-3 text-center">
              <button
                onClick={this.handleLogin}
                className="btn btn-gradient bt-wd"
              >
                Login
              </button>
            </div>
          </div>
        </Modal>
      </>
    );
  }
}

export default BusinessDetails;
